import {Component, OnInit} from "@angular/core";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import {Article} from "../../model/catalog/article.model";
import {CatalogApiService} from "../../api/catalog-api.service";

@Component({
  selector: 'app-home-catalogue',
  templateUrl: './home-catalogue.component.html',
  styleUrls: ['./home-catalogue.component.scss']
})
export class HomeCatalogueComponent implements OnInit {

  arrow = faAngleDoubleRight;
  itemGroups: Array<{ title: string, items: Array<Article> }> = [];

  constructor(private catalog: CatalogApiService) {
  }

  ngOnInit() {
    this.catalog.getSampleArticles().subscribe((catalogItems) => {
      this.itemGroups.push({
        title: "home.catalog.care",
        items: catalogItems.filter(item => item.type === "CARE")
      });

      this.itemGroups.push({
        title: "home.catalog.accessories",
        items: catalogItems.filter(item => item.type === "ACCESSORY")
      });

    });
  }
}
